export const rotas = {
  cadastroPage: "/cadastroPage",
  perfil: "/cadastro/perfil",
  usuario: "/cadastro/usuario",
  trem: "/cadastro/trem",
};